import { autoserialize } from 'cerialize';

export class DriverEarnings {
  @autoserialize
  available: boolean;

  @autoserialize
  reservationId: number;

  @autoserialize
  driverDistanceRate: number;

  @autoserialize
  driverTimeRate: number;

  @autoserialize
  driverBaseFare: number;

  @autoserialize
  driverDistanceFare: number;

  @autoserialize
  driverTimeFare: number;

  @autoserialize
  driverIncentive: number;

  @autoserialize
  driverCommissionAmount: number;

  @autoserialize
  driverMinimumFare: number;

  @autoserialize
  driverMinimumFareUsedToCalculateDriverCommissionAmount: boolean;

  @autoserialize
  distanceMiles: number;

  @autoserialize
  durationMinutes: number;

  @autoserialize
  durationSeconds: number;

  @autoserialize
  tollReimbursementAmount: number;

  @autoserialize
  driverPaymentAmount: number;
}
